export enum SettingsType {
	User,
	UserGroup,
	App
}